
const keyDeErrorLogin = {
    usuarioNoVal: "usuNoVal",
    nombreVacio: "nomVacio",
    contraVacia: "contraVacia",
};


export {keyDeErrorLogin };
